export default "__VITE_ASSET__BOQP4PMl__"